<template>
  <div class="form_content">
    <ux-form
      class="el_form"
      ref="form"
      :data="formData"
      label-width="auto"
      data-automation="addProduct"
      @close="close"
      @confirm="confirm"
    >
      <div class="form_box">
        <div class="form_item_one">
          <div class="title">
            {{$t('HT.debug1.apiId')}}
            <div class="title_chek" @click="selectAll">{{ $t('HT.router.api.selectAll') }}</div>
          </div>
            <div class="select_box">
              <el-select class="api_select" v-model="selectApiVal" @change="getApiData">
                <el-option v-for="item in apiGroupList" :label="item.name" :key="item.id" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="chekbox_box">
              <div class="chekbox_item" v-for="(item,index) in apiList" :key="item.id" @click="addCopyList(item,index)">
                <div class="chebox_info">
                  <div class="chekbox_name">
                    {{ item.name }}
                  </div>
                  <div class="chekbox_type">
                    {{$t('HT.router.api.apiType')}}：{{item.name}}
                  </div>
                </div>
                <div class="chekbox_arrow">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
        </div>
        <div class="form_item_one">
          <div class="title" style="border-bottom: none;">
            {{$t('HT.bindFlowApi.text')}}（{{copyApiData.length||0}}）
            <div class="title_chek" @click="delCopyDataAll">{{$t('HT.router.api.delSelectAll')}}</div>
          </div>
          <div class="chekbox_box" style="height: 464px;">
            <div class="chekbox_item" v-for="(item, index) in copyApiData" :key="index">
              <div class="chebox_info">
                <div class="chekbox_name">
                  {{ item.name }}
                </div>
                <div class="chekbox_type">
                  {{$t('HT.router.api.apiType')}}：{{item.name}}
                </div>
              </div>
              <div class="chekbox_close">
                <i class="el-icon-circle-close" style="font-size: 20px;color: #606266;cursor: pointer;" @click="delCopyData(item,index)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ux-form>
  </div>
</template>

<script>
export default {
  props: {
    apiData: {
      type: Array,
      default: []
    },
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          remark: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      apiItem: [],
      nameItem: [],
      // Api分组数据
      apiGroupList: [],
      // Api列表数据
      apiList: [],
      copyApiData: [],
      value: [],
      // 高亮控制
      activeState: '',
      selectApiVal: '',
      list:[]
    };
  },
  created() {
    this.getApigroup();
  },
  methods: {
    // 单项选择
    addCopyList(item,index){
      this.mergeArr([item]);
      this.apiList.splice(index, 1);
    },
    delCopyData(item,index){
      this.copyApiData.splice(index, 1);
      if(item.typeId==this.selectApiVal){
        this.apiList.push(item);
      }
    },
    delJson(newList, oldlist) {
      let arr = oldlist.map(i => i['id']);
      let result = newList.filter(i => !arr.includes(i['id']));
      return result;
    },
    // 全部选择
    selectAll(){
      this.mergeArr(this.apiList);
      this.apiList = [];
    },
    // 合并已选API数据
    mergeArr(arr){
      let list = this.delJson(arr,this.copyApiData);
      let copyArr = [...this.copyApiData,...list];
      this.copyApiData= copyArr;
    },
    // 删除全部选择
    delCopyDataAll(){
      // 选择api列表，只回显当前api类型数据
      let delList = this.copyApiData.filter(val=>val.typeId==this.selectApiVal);
      this.apiList = [...this.apiList,...delList];
      this.copyApiData= [];
    },
    /**
     * Api分组
     */
    getApigroup() {
      this.$api.product.getProductApiInfogroup().then((res) => {
        let resData = res.data||[];
        this.apiGroupList = resData.length?[{id:-1,name:'全部'},...resData]:resData;
        this.selectApiVal = -1;
        this.getApiData(this.selectApiVal);
      });
    },
    /**
     * 获取api分组下面的api
     * @param {Number} id
     */
    getApiData(val) {
      this.$api.group.getProductApigroup(val).then((res) => {
        // 获取当前api类型
        if (res.code === 10000) {
          let typeName = this.apiGroupList.filter(item=>item.id==val);
          let {id,name} = typeName[0];
          let resData = res.data||[];
          resData.forEach(item => {
            item.typeName = name;
            item.typeId = id;
          });
          // 过滤已选API项
          this.apiList = this.findDiffEl(resData,this.copyApiData);
        }
      });
    },
    // 查找两数组不同的数据
    findDiffEl(arr1, arr2) {
      var diff = []; // 存放不相同的元素
      for (var i = 0; i < arr1.length; i++) {
        if (!this.isIdArray(arr1[i], arr2)) {
          diff.push(arr1[i]);
        }
      }

      return diff;
    },
    // 判断是否有相同id在数组中
    isIdArray(el, array) {
      for (var j = 0; j < array.length; j++) {
        if (array[j].id=== el.id) {
          return true;
        }
      }
      return false;
    },
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },
    /**
     * 确认回调
     */
    confirm() {
      let res = this.copyApiData;

      if (res.length == 0) {
        this.$uxMessage.warning(this.$t('HT.addApi.placeholder'));
        return;
      }
      let order = this.apiData.length;
      let postData = [];
      for (let i = 0; i < res.length; i++) {
        let item = res[i];
        postData.push({
          id: item.id,
          type: 'API',
          order: order + i + 1
        });
      }

      this.$emit('confirm', postData);
    },
    removeItem(data) {
      this.copyApiData = this.copyApiData.filter(item => {
        return item != data;
      });
      data.flag = false;
      // this.copyApiData.splice
    }
  }
};
</script>

<style lang="scss">
.form-select {
  width: 96% !important;
  display: block;
  margin-top: 16px;
}
.form_content {
  width: 900px;
  font-size: 16px;
  color: #606266;
  position: relative;
  .el_form {
    .form_box{
      display: flex;
      justify-content: space-between;
    }
    .form_item_one {
      width: 445px;
      text-align: center;
      .title {
        font-weight: 550;
        font-size: 14px;
        text-align: center;
        border: 1px solid rgba(228, 231, 237, 1);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        height: 50px;
        background: #FCFAF9;
      }
      .title_chek{
        color: #0087ff;
        cursor: pointer;
      }
    }
    .select_box{
      width: 100%;
      border-right: 1px solid rgba(228, 231, 237, 1);
      border-left: 1px solid rgba(228, 231, 237, 1);
    }
    .api_select{
      width: 96%;
      margin: 12px auto;
    }
    .chekbox_box{
      width: 100%;
      overflow-y: scroll;
      height: 400px;
      border: 1px solid rgba(228, 231, 237, 1);
    }
    .chekbox_box .chekbox_item{
      border-bottom: 1px solid rgba(228, 231, 237, 1);
      height: 60px;
      text-align: left;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      .chekbox_name{
        font-size: 18px;
      }
      .chekbox_type{
        font-size: 14px;
        margin-top: 4px;
      }
    }
    .chekbox_arrow{
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      text-align: center;
      border: 1px solid rgba(228, 231, 237, 1);
      border-radius: 5px;
    }
  }
}
</style>
